import { indexDBStorage } from "shared/storage/indexDBStorage";
import { AppConfigExtended, DeviceType } from "../typings";
import { OnlineConfig } from "@npd-ng/adp-types";
import { UAParser } from 'ua-parser-js';
const parser = new UAParser();
function getPlatformFromUserAgent() {
  const ua = window.navigator.userAgent;
  if (/Windows NT/.test(ua)) {
      return 'Windows';
  } else if (/Macintosh/.test(ua)) {
      return 'macOS';
  } else if (/Linux/.test(ua)) {
      return 'Linux';
  } else if (/CrOS/.test(ua)) {
      return 'chromeOS';
  } else if (/Android/.test(ua)) {
      return 'Android';
  } else if (/iPhone|iPad|iPod/.test(ua)) {
      return 'iOS';
  } else {
      return 'Unknown';
  }
}
function getParsedUserAgent(){
    return parser.getResult();
}
function randomstring(L: number) {
    var s = '';
    var randomchar = function() {
      var n = Math.floor(Math.random() * 62);
      if (n < 10) return n; //1-10
      if (n < 36) return String.fromCharCode(n + 55); //A-Z
      return String.fromCharCode(n + 61); //a-z
    }
    while (s.length < L) s += randomchar();
    return s;
  }

function isPageReloaded(){
  const performanceNavigation =window.performance.getEntries()[0] as PerformanceNavigationTiming
  console.info("[ADP Student App] performanceNavigationType",performanceNavigation.type);
  if (performanceNavigation) {
    if(performanceNavigation.type=== "reload")
    return true;
    else return false;
 
  }
  else {
    return false;
  }
}  
function formatDate(date: Date,time=false){
  const d = new Date(date);
  let month = '' + (d.getMonth() + 1);
  let day = '' + d.getDate();
  const year = d.getFullYear();
  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;
  if(time){
      const sec = d.getSeconds();
      const milisec = d.getMilliseconds();
      const hour = d.getHours();
      return [year, month, day,hour, sec, milisec].join('-');
  }
  else{
      return [year, month, day].join('-');
  }
    
}
function getEnvironment(){
  let loc = window.location.href.split(".")
  let env = loc.length > 1  ? loc[1] : "dev25";
  if (window.location.href.includes('127.0')){
      env = "dev25";
  }
 
  console.log(`[Config][get environmnet][current environment: ${env}]`);
  return env; 
}
function getDomain(){
  const location =window.location.origin;
  const currentPath = window.location.href.replace("index.html", "");
  const domain = location.includes('localhost') ? "http://localhost:3000/" : currentPath;
  const domainWithoutQueryParam = domain?.split("?")[0];
  return domainWithoutQueryParam;
}
function getENAEPDomain(){
  const location =window.location.origin;
  const domain = location.includes('localhost') ? "https://enaep.dev25.npdng.org" : `${location}`;
  return domain;
}
function getApiDomain(config: AppConfigExtended | undefined){
  const hostname =window.location.host;
  const protocol = window.location.protocol
  // const domain = hostname.includes('localhost') ? `https://${config?.[config.onlineMode].apiSubDomain}.enaep.dev25.npdng.org` : `${protocol}//${config?.[config.onlineMode].apiSubDomain}${hostname}`;
  const domain = hostname.includes('localhost') ? `https://enaep.dev25.npdng.org` : `${protocol}//${config?.[config.onlineMode].apiSubDomain}${hostname}`;
  // const domain = `${protocol}//${config?.[config.onlineMode].apiSubDomain}${hostname}`;
  return domain;
}
function isLocalhost(){
  const hostname =window?.location.hostname;
 return hostname?.includes('localhost')
}
function resolveNCSDomain(){
  const urlParams = new URLSearchParams(window.location.search);
  const params = Object.fromEntries(urlParams.entries());
  let apiUrl = params.lcs_api_url;
  return apiUrl ? apiUrl.split(":")[0] : false
}
function getQueryParams(){
  const params = new URL(window.location.href).searchParams
  return params;
}
function getPathName(){
  return window.location.pathname;
}
const environment={
  resovleAppDomain: getDomain,
  resolveApiDomain: getApiDomain,
  resolveENAEPDomain: getENAEPDomain
}
function skipValidation(){
  const params = getQueryParams();
  const skipValidation = params.has("skipValidation","true")
  console.log("skipValidation",skipValidation)
  return skipValidation;
}

function bypassMaintenance(){
  const params = getQueryParams();
  const bypassMaintenance = params.has("bypassMaintenance","true")
  console.log("bypassMaintenance",bypassMaintenance)
  return bypassMaintenance;
}

function sleep(ms:number) {
  return new Promise(resolve => setTimeout(resolve, ms));
}
const getDeviceIdFromStorage = async ()=>{
  try {
    const instance =  await indexDBStorage.getInstance();
    const deviceId = await instance.transactions.get("adp-session-references","uniqueDeviceId");
    return deviceId
  }
 catch (e){
  console.warn("Error retrieving device id from storage", e);
  return undefined;
 }
  }
  const storeDeviceId = async (deviceId:string)=>{
    try {
      const instance =  await indexDBStorage.getInstance();
      await instance.transactions.put("adp-session-references",deviceId,"uniqueDeviceId");
      return true;
    }
   catch (e){
    console.warn("Error storing device id", e);
    return undefined;
   }
    }
 const getDeviceType= ():DeviceType =>{
  let deviceType:DeviceType = "SBE";
  if(getPathName().includes("/adp-web-app/npn/")){
     deviceType = "NPE";
     console.log("Device is managed by naep", getPathName());
  } 
  console.info("[Util] Changing device type to ", deviceType);
  return deviceType
}
const getDeviceId = (deviceId?:string):string=>{
  if(deviceId && deviceId!=''){
    const sanitizedDeviceId = deviceId.replace(/[^a-z0-9]/gi, '')
    if(getDeviceType() === "NPE"){
      return sanitizedDeviceId;
    }
    else {
      const modifiedDeviceId = `${sanitizedDeviceId}SD`
      const base64Encoded = btoa(modifiedDeviceId);
      let cleanedString = base64Encoded?.slice(1);
    // Remove special characters (keeping only alphanumeric)
      cleanedString = cleanedString?.replace(/[^a-zA-Z0-9\s]/gi,'');
      return `SD${cleanedString}`
    }
  }
  else {
    const randomId = `SD${randomstring(5).toUpperCase()}SD`;
    const base64Encoded = btoa(randomId);
    let cleanedString = base64Encoded?.slice(1);
    // Remove special characters (keeping only alphanumeric)
    cleanedString = cleanedString?.replace(/[^a-zA-Z0-9\s]/gi,'');
    return `SDR${cleanedString}`
  }
}
const logPrefix = "[ADP Web App]"
const getOnlineServices = (config: AppConfigExtended | undefined): OnlineConfig | undefined =>{
  //console.log('config',config?.[config.onlineMode], config)
  return config?.[config.onlineMode];
}

export function getAspectRatio() {
  const width = window.screen.width;
  const height = window.screen.height;

  const gcd:any = (a:number, b:number) => {
      if (b === 0) return a;
      return gcd(b, a % b);
  };

  const greatestCommonDenominator = gcd(width, height);

  return `${width / greatestCommonDenominator}:${height / greatestCommonDenominator}`;
}

export const formatBytes = (bytes: number) => {
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];

  let i = 0;

  for (i; bytes >= 1000 && i < 4; i++) {
    bytes /= 1000;
  }

  return `${bytes.toFixed(2)} ${units[i]}`;
};
export const checkStorageQuota = async ()=>{
  try {
      const storageQuota = await navigator.storage.estimate();
      console.log("[ADP-Extension]","Storage Quota", storageQuota);
      const storageQuotaConverted = {
          quota: storageQuota?.quota,
          usage: storageQuota?.usage,
          quotaMB: formatBytes(storageQuota?.quota || 0),
          usageMB: formatBytes(storageQuota?.usage || 0),
          usageDetails: { // @ts-ignore
             caches: formatBytes(storageQuota.usageDetails?.caches || 0), // @ts-ignore
             indexedDB: formatBytes(storageQuota.usageDetails?.indexedDB || 0), // @ts-ignore
             serviceWorkerRegistrations: formatBytes(storageQuota.usageDetails?.serviceWorkerRegistrations || 0)
          }
      }
      console.log("[ADP-Extension]","Storage Quota converted", storageQuotaConverted);
      return storageQuotaConverted;
  }
 catch(e){
      console.warn("[ADP-Extension]","Failed to estimate local storage quota", e); 
      return undefined;
 }
}
export * from "./constants";
export {bypassMaintenance,getDeviceId,getParsedUserAgent,getPlatformFromUserAgent,storeDeviceId,getEnvironment,isLocalhost,randomstring,isPageReloaded,environment,sleep,formatDate,resolveNCSDomain,getQueryParams,getPathName,skipValidation,getDeviceIdFromStorage,getDeviceType,getOnlineServices};